---
fr:
  fall_lease:
    accumulated: Accumulé
    actions: Actions
    active: Actif
    approve: Approuver
    approve_prompt: Vous êtes sur le point de remplacer le calcul existant. Êtes-vous sûr⋅e de vouloir approuver ?
    approved: Approuvé
    averaging_interval: Intervalle de moyenne
    back: Retour
    calculation_interval: Intervalle de calcul
    code_list: Liste de codes
    computable: Calculable
    computable_computing: Le calcul est en cours
    computable_false: Échec du calcul. Veuillez vérifier si tous les paramètres sont corrects, ou contactez Kaia.
    computable_true: Le calcul fonctionne normalement
    computable_unknown: Non calculé
    computation_state: État du calcul
    compute: Calculer
    compute_all_prompt: |-
      Vous êtes sur le point de calculer tous les baux d'automne.
      La tâche prendra de 1 à 5 minutes pour se terminer.
      Êtes-vous sûr?
    compute_current_year: Calculer l'année en cours
    computing_job_status:
      in_queue: En file d'attente
      not_found: Non trouvé, cliquez pour réessayer
      running: En cours
    computing_status: Statut de calcul
    confirm_code_list_clear: Vous allez vider la liste des codes de compte. Veuillez confirmer.
    contract_details: Détails du contrat
    contract_id: ID du contrat
    contract_nr: Contrat \#
    contract_structure: Structure contractuelle
    contract_type: Type de contrat
    counterpart: Contrepartie
    counterpart_fields:
      add: Ajouter une contrepartie
      fall_lease: Concession
      informational_text_accuracy: Des inexactitudes et des erreurs se produiront à la fois pour les années en cours et historiques.
      informational_text_test: Ceci est une version de test.
      landowner: Propriétaire foncier
      landowner_error: Un propriétaire foncier doit être sélectionné
      share: Part[%]
      share_error: La part totale ne doit pas dépasser 100%
      show_landowner_info: Informations sur le propriétaire foncier de bail d'automne
    currency: Devise
    disapprove: Désapprouver
    download_xlsx: Télécharger (xlsx)
    elcert: Elcert
    elcert_codes: Liste de codes Elcert
    elcert_owners: Propriétaires d'Elcert
    elcert_share: Part d'Elcert
    end_date: Date de fin
    fall_lease: Concession
    fall_lease_contract_details: Détails de la concession
    fall_lease_contracts: Concessions
    fall_lease_summary: Résumé de la concession
    filter_data: Filtrer les données
    fixed_price: Location de terrain
    goos: GoOs
    goos_codes: Liste de codes GoOs
    goos_owners: Propriétaires de GoOs
    goos_share: GoO partage
    gross: Brut
    kpi_adjustment: Ajustement du KPI
    kpi_end_date_type: Date de fin du KPI
    kpi_ref_date: Date de réf. du KPI
    loading_please_wait: Chargement en cours... Veuillez patienter
    lock: Verrouiller
    lock_all: Verrouiller toutes les années
    lock_prompt: Vous êtes sur le point de verrouiller les paramètres. Êtes-vous sûr de vouloir verrouiller ?
    lock_prompt_false: Vous déverrouillez maintenant des paramètres. Êtes-vous sûr de vouloir déverrouiller ?
    lock_prompt_true: Vous verrouillez maintenant des paramètres. Êtes-vous sûr de vouloir verrouiller ?
    locked: Verrouillé
    min_price: Niveau de location minimum
    model_rate: Taux de modèle - Revenus de vente d'électricité
    model_rate_hint: 'Par exemple: 5'
    model_type: Type de modèle
    net: Brut avec coûts
    none: Aucun
    payment_dates: Dates de paiement
    payment_interval: Intervalle de paiement
    power_plant_name: Nom de la centrale
    pp_revenues_costs: Revenus et coûts de la centrale électrique
    rate_structure: Structure tarifaire
    remove_all: Supprimer toutes les années
    remove_all_prompt: |-
      Vous êtes sur le point de SUPPRIMER TOUS les baux d'automne de centrale électrique.
      Êtes-vous sûr?
    revenue: Revenu
    revenue_codes: Liste de codes de revenus
    revenue_owners: Propriétaires de Revenus
    save: Enregistrer
    save_all_years: Sauvegarder toutes les années
    save_and_compute: Enregistrer et calculer
    save_compute_all: Calculer toutes les années
    select_cols_show: Sélectionner les colonnes à afficher
    select_columns_to_show: Sélectionner les colonnes à afficher
    start_date: Date de début
    threshold_method: Méthode de calcul du seuil
    threshold_rate: Taux de seuil
    threshold_rate_hint: 'Par exemple: 10, 15, 25'
    threshold_type: Type de seuil
    threshold_value: Valeur du seuil
    threshold_value_hint: 'Par exemple: 0, 16000, 50000'
    total: Total
    total_costs: Coûts totaux
    total_costs_codes: Liste de codes de coûts totaux
    total_costs_owners: Propriétaires de Coûts
    total_fall_leases: Total de la concession
    unlock: Déverrouiller
    unlock_all: Déverrouiller toutes les années
    websocket_connected: Connecté au serveur
    websocket_disconnected: Déconnecté du serveur
    xledger_api:
      insufficient_credits: XLedger crédits insuffisants, réinitialisation à %{reset_at}
    xledger_id_not_found: L'ID de projet XLedger n'est pas défini pour cette centrale
    yearly_production: Production annuelle
